import eventLogger from 'lib/EventLogger';
import { EventType, SourcePages } from 'lib/EventSchema';
import { EventContext, EventData } from 'lib/EventLogger/Event';

interface TrackDealerPagesClickArgs {
  type: string;
  label?: string;
  dealerPageUrl?: string;
  targetPageUrl?: string;
}

// eslint-disable-next-line import/prefer-default-export
export function trackDealerPagesClick({
  type,
  label,
  dealerPageUrl,
  targetPageUrl,
}: TrackDealerPagesClickArgs): void {
  const eventContext: EventContext = {};
  if (targetPageUrl) eventContext.target_page = targetPageUrl;
  if (label) eventContext.engagement_label = label;
  if (dealerPageUrl) eventContext.page_name = `/dealers/${dealerPageUrl}`;

  eventLogger.log({
    event_type: EventType.dealerPageEngagement,
    engagement_type: type,
    source_page: SourcePages.DealerPage,
    event_context: eventContext,
  });
}

export default function DealerLandingPageViewEvent(vin: string, dealerId: string): EventData {
  return {
    event_type: EventType.view,
    view_type: 'page_view',
    source_page: SourcePages.DealerLandingPage,
    event_context: {
      url: `/dealer?vin=${vin}&id=${dealerId}`,
    },
  };
}
